export default "__VITE_ASSET__621662b2__"